var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('list-item',{attrs:{"title":"InfusionSoft","list":_vm.list},on:{"delete":_vm.removeInfusionSoft}}):_c('div',{staticClass:"container-loading"},[_c('b-spinner',{attrs:{"label":"Loading..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }